module.exports = __webpack_public_path__ + "img/40_38_064_940.fe832586.jpg";